import { NavItem, NavItemGroup } from 'types';

import { useSettingsData } from 'hooks/useSettingsData';

import { Dropdown } from 'components/Dropdown';

import * as S from './SettingsBar.styles';

const useSettingsBar = () => {
  const groupItemsRendered = useSettingsData()?.map((group: NavItemGroup) => (
    <S.Group key={group.id}>
      {group?.items.map((item: NavItem) => (
        <S.GroupItem hidden={item.hidden} key={item.order} hasBorder={item.hasBorder}>
          {item.list && item.list.length > 0 ? (
            <Dropdown
              label={item.label}
              items={item.list}
              motive="settings"
              fontWeight="extraLight"
              itemMotive="settings"
              scale="s"
              itemsHasBorder
              iconLeft={item.iconLeft}
              iconRight={item.iconRight}
              settingsBarItem
              onScrollEnd={item.onScrollEnd}
              alignLeft={item.menuAlign === 'left'}
              wideTrigger={item.wideTrigger}
              triggerMinWidth={item.triggerMinWidth}
            />
          ) : (
            <S.SettingsButton
              asLink
              scale="xs"
              motive={item.hasUnderscore ? 'inlineUnderline' : 'settings'}
              to={item.to}
              onClick={item.onClick}
              fontWeight="extraLight"
              fontFamily="LFT Zeno"
            >
              {item.label}
            </S.SettingsButton>
          )}
        </S.GroupItem>
      ))}
    </S.Group>
  ));

  return {
    groupItemsRendered,
  };
};

export { useSettingsBar };
